import { CollectedData } from 'src/interfaces/collectedData'
import { CollectedDataApprovalType } from 'src/constants/collectedData'

/**
 * Whether the user can set effective and expiration dates when approving this step.
 * True when it's a combined step with CustomerApproval or InternalThenCustomerApproval.
 */
export function canSetDatesOnApprove(
  collectedData: CollectedData,
  isCombinedStep: boolean,
): boolean {
  const { approvalType } = collectedData.collectDataStep

  return (
    isCombinedStep &&
    (approvalType === CollectedDataApprovalType.CustomerApproval ||
      approvalType === CollectedDataApprovalType.InternalThenCustomerApproval)
  )
}
